import TemplateNewForm from "../../../../../pages/app/admin/library/templates/TemplateNewForm";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../../ElevatedPaper";

const ProviderTemplateHost = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)" }}>
      <TemplateNewForm />
    </ElevatedPaper>
  );
};

export default ProviderTemplateHost;
